import { Routes, Route } from "react-router-dom"

import Auth from "./routes/Auth"
import Admin from "./routes/Admin"
import { AuthRoute, PrivateRoute, DefaultRoute } from "./components/Shared/Routes";

import "./utils/axiosInterceptor";

import "./App.css";


function App(props) {
    return (
        <Routes>
            <Route element={<AuthRoute />}>
                <Route path="auth/*" element={<Auth />} />
            </Route>
            
            <Route element={<PrivateRoute />}>
                <Route path="admin/*" element={<Admin />} />
            </Route>
            
            <Route path="*" element={<DefaultRoute />} />
        </Routes>
    );
}

export default App;